module.exports = __webpack_public_path__ + "static/media/ellipse.92a0200f.svg";